import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HeroSectionB } from '../components/HeroSectionB';
import { SignalSection } from '../components/SignalSection';
import { SymptomsSection } from '../components/SymptomsSection';
import { SignalBridge } from '../components/SignalBridge';
import { AnticipationSection } from '../components/AnticipationSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { QuizSection } from '../components/QuizSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
const getVariant = (): string => {
  if (typeof window === 'undefined') return 'a';
  return new URLSearchParams(window.location.search).get('v') ?? 'a';
};
export function LandingPage() {
  const variant = getVariant();
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-438" data-mp="3dcesj2n7kuq2">

      {/* Concepto 2: Señal con reveal secuencial */}
      <SignalSection data-id="element-439" data-mp="3n7q63hmvrvw8" />

      {/* Espejo emocional — justo después de "tu cuerpo no falló" */}
      <SymptomsSection data-id="element-440" data-mp="3r9uyye5i8oht" />

      {/* Puente visual — la señal H·E·R a escala reducida, guiando hacia la promesa */}
      <SignalBridge data-id="element-441" data-mp="2qunr0qvgd3" />

      {/* Test A/B: solo el hero cambia */}
      {variant === 'b' ? <HeroSectionB data-id="element-442" data-mp="1wwvdi4eg102m" /> : <HeroSection data-id="element-443" data-mp="1wxdhjn7ckil3" />}

      {/* Concepto 4: Protocolo con journey bar + fases interactivas */}
      <ProtocolSection data-id="element-444" data-mp="21w81ish1wd6s" />

      {/* Quiz H.E.R. — descubrí qué fase conecta más con vos */}
      <QuizSection data-id="element-445" data-mp="3573y4rian55x" />

      {/* Concepto 3: Anticipación — el destino antes del vehículo */}
      <AnticipationSection data-id="element-446" data-mp="307re0eit4c71" />

      <BenefitsSection data-id="element-447" data-mp="308kb0nryrnbz" />
      <PainSection data-id="element-448" data-mp="309c5fv9trf0o" />
      <TestimonialsSection data-id="element-449" data-mp="3e6iolqygnfqf" />
      <ForWhoSection data-id="element-450" data-mp="3e7to3ekvi1bq" />
      <BibliotecaSection data-id="element-451" data-mp="3e8brqw9v7hto" />

      {/* Antes/Después + cierre de identidad — justo antes del CTA */}
      <DifferenceSection data-id="element-452" data-mp="396cqbrxoquzd" />

      <OfferSection data-id="element-453" data-mp="39a0hwljkl7bg" />
      <AboutSection data-id="element-454" data-mp="3o4ev25ggdmi7" />
      <FAQSection data-id="element-455" data-mp="3o3wrsovdi80s" />
      <FinalCTASection data-id="element-456" data-mp="3o3dks379h41j" />

    </main>;
}